// import React from "react";

// const destinations = [
//   {
//     id: 1,
//     name: "Alibag",
//     image: "/images/network/Alibag.png",
//   },
//   {
//     id: 2,
//     name: "Goa",
//     image: "/images/network/goa.png",
//   },
//   {
//     id: 3,
//     name: "Kolhapur",
//     image: "/images/network/kolhapur.png",
//   },
//   {
//     id: 4,
//     name: "Lavasa",
//     image: "/images/network/Lavasa.png",
//   },
//   {
//     id: 5,
//     name: "Lonavala",
//     image: "/images/network/Lonavala.png",
//   },
//   {
//     id: 6,
//     name: "Mahabaleshwar",
//     image: "/images/network/Mahabaleshwar.png",
//   },
//   {
//     id: 7,
//     name: "Mumbai",
//     image: "/images/network/mumbai.png",
//   },
//   {
//     id: 8,
//     name: "Nashik",
//     image: "/images/network/nashik.png",
//   },
//   {
//     id: 9,
//     name: "Pune",
//     image: "/images/network/pune.png",
//   },

//   // {
//   //   id: 11,
//   //   name: "Ratnagiri",
//   //   image: "/images/network/Ratnagiri.png",
//   // },
//   {
//     id: 12,
//     name: "Chhatrapati Sambhajinagar",
//     image: "/images/network/sambhaji-nagar.png",
//   },
//   {
//     id: 13,
//     name: "Satara",
//     image: "/images/network/Satara.png",
//   },
//   {
//     id: 14,
//     name: "Shirdi",
//     image: "/images/network/shirdi.png",
//   },
// ];

// const OurNetwork = () => {
//   return (
//     <>
//       {/* Hero Section */}

//     <div className="page-headder bg-section parallaxie">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="page-header-box text-white">
//                 <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
//                   Our  Network
//                 </h1>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>




//       {/* Destination Cards */}
//       <section className="destination-wrapper-section">
//         <div className="container">
//           <div className="row">
//             {destinations.map((place) => (
//               <div
//                 className="col-xl-3 col-lg-4 col-md-6 mb-5"
//                 key={place.id}
//               >
//                 <div className="destination-box-card">

//                   <div className="destination-image-box">
//                     <img
//                       src={place.image}
//                       alt={place.name}
//                       className="destination-main-image"
//                     />
//                   </div>

//                   <div className="destination-content-area">
//                     <h3 className="destination-city-name">
//                       {place.name}
//                     </h3>

//                     <div className="destination-line"></div>

//                     <button className="destination-explore-btn">
//                       Explore
//                     </button>
//                   </div>

//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default OurNetwork;











import React from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
} from "react-leaflet";

import L from "leaflet";
import "leaflet/dist/leaflet.css";

import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

// Fix Leaflet marker issue
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const destinations = [
  {
    id: 1,
    name: "Alibag",
    image: "/images/network/Alibag.png",
    position: [18.6414, 72.8722],
  },
  {
    id: 2,
    name: "Goa",
    image: "/images/network/goa.png",
    position: [15.2993, 74.124],
  },
  {
    id: 3,
    name: "Kolhapur",
    image: "/images/network/kolhapur.png",
    position: [16.705, 74.2433],
  },
  {
    id: 4,
    name: "Lavasa",
    image: "/images/network/Lavasa.png",
    position: [18.4064, 73.5067],
  },
  {
    id: 5,
    name: "Lonavala",
    image: "/images/network/Lonavala.png",
    position: [18.7546, 73.4062],
  },
  {
    id: 6,
    name: "Mahabaleshwar",
    image: "/images/network/Mahabaleshwar.png",
    position: [17.9307, 73.6477],
  },
  {
    id: 7,
    name: "Mumbai",
    image: "/images/network/mumbai.png",
    position: [19.076, 72.8777],
  },
  {
    id: 8,
    name: "Nashik",
    image: "/images/network/nashik.png",
    position: [20.011, 73.7903],
  },
  {
    id: 9,
    name: "Pune",
    image: "/images/network/pune.png",
    position: [18.5204, 73.8567],
  },
  {
    id: 12,
    name: "Chhatrapati Sambhajinagar",
    image: "/images/network/sambhaji-nagar.png",
    position: [19.8762, 75.3433],
  },
  {
    id: 13,
    name: "Satara",
    image: "/images/network/Satara.png",
    position: [17.6805, 74.0183],
  },
  {
    id: 14,
    name: "Shirdi",
    image: "/images/network/shirdi.png",
    position: [19.7645, 74.4774],
  },
];

const OurNetwork = () => {
  return (
    <>
      {/* Hero Section */}
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  Our Network
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

{/* 
    <section className="destination-wrapper-section py-5">
        <div className="container">

          <div className="row">

            {destinations.map((place) => (
              <div
                className="col-xl-3 col-lg-4 col-md-6 mb-4"
                key={place.id}
              >
                <div className="destination-box-card">

                  <div className="destination-image-box">
                    <img
                      src={place.image}
                      alt={place.name}
                      className="destination-main-image"
                    />
                  </div>

                  <div className="destination-content-area">

                    <h3 className="destination-city-name">
                      {place.name}
                    </h3>

                    <div className="destination-line"></div>

                    <button className="destination-explore-btn">
                      Explore
                    </button>

                  </div>

                </div>
              </div>
            ))}

          </div>

        </div>
      </section> */}

<section className="destination-section-modern py-5">
  <div className="container">

    {/* Heading */}
    <div className="text-center mb-5">
      <h6 className="destination-subtitle">POPULAR DESTINATIONS</h6>
      <h2 className="destination-title">Explore Top Travel Spots</h2>
      <p className="destination-desc">
        Discover amazing destinations with comfortable travel experience
      </p>
    </div>

    <div className="row g-4">

      {destinations.map((place) => (
        <div className="col-xl-3 col-lg-4 col-md-6" key={place.id}>

          <div className="destination-card-modern">

            {/* Image */}
            <div className="destination-img-wrapper">
              <img src={place.image} alt={place.name} />

              {/* ALWAYS VISIBLE NAME */}
              <div className="destination-name-badge">
                {place.name}
              </div>

              {/* Overlay button only */}
              <div className="destination-overlay">
                <button className="destination-btn">
                  Explore
                </button>
              </div>

            </div>

          </div>

        </div>
      ))}

    </div>

  </div>
</section>
      

      {/* Map Section */}
      <section className="network-map-section py-5">
        <div className="container">

          <div className="text-center mb-5">
            <h2 className="fw-bold">
              Extensive Routes Across Maharashtra & Goa
            </h2>

            <p className="text-muted">
              Aaradhya Travels Network Across Major Destinations
            </p>
          </div>

          <div className="row">

            <div className="col-lg-8 mb-4">

              <div
                className="shadow rounded-4 overflow-hidden"
                style={{ height: "600px" }}
              >
                <MapContainer
                  center={[18.8, 74.5]}
                  zoom={6}
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <TileLayer
                    attribution="&copy; OpenStreetMap contributors"
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />

                  {destinations.map((city) => (
                    <Marker
                      key={city.id}
                      position={city.position}
                    >
                      <Popup>
                        <strong>{city.name}</strong>
                        <br />
                        Aaradhya Travels Service Location
                      </Popup>
                    </Marker>
                  ))}
                </MapContainer>
              </div>

            </div>

            <div className="col-lg-4">

              <div className="network-card shadow-lg p-4 bg-white rounded-4">

                <h4 className="fw-bold mb-4">
                  Network Locations
                </h4>

                {destinations.map((city) => (
                  <div
                    key={city.id}
                    className="d-flex align-items-center mb-3 pb-2 border-bottom"
                  >
                    <span
                      style={{
                        color: "#ff5722",
                        fontSize: "18px",
                        marginRight: "10px",
                      }}
                    >
                      📍
                    </span>

                    <span>{city.name}</span>
                  </div>
                ))}

                <div className="row text-center mt-4">

                  <div className="col-4">
                    <h3 className="text-primary fw-bold">
                      35+
                    </h3>
                    <small>Cities</small>
                  </div>

                  <div className="col-4">
                    <h3 className="text-success fw-bold">
                      50+
                    </h3>
                    <small>Vehicles</small>
                  </div>

                  <div className="col-4">
                    <h3 className="text-danger fw-bold">
                      20K+
                    </h3>
                    <small>Clients</small>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>
      </section>

      {/* Destination Cards */}
  
    </>
  );
};

export default OurNetwork;